
export default function( umbrella ) {
    const { fetch } = umbrella;

    const eventProxyUrl = umbrella.isLocalhost() ? 'https://qa.api.biw.cloud/v1/web-event-proxy' : `https://${ window.location.hostname }/api/v1/web-event-proxy`;

    async function sendEvent( eventData, topicName ) {
        const res = await fetch( `${ eventProxyUrl }/topics`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify( {
                eventData,
                topicName
            } )
        } );

        const data = await res.json();
        if ( res.ok ) {
            return data;
        } else {
            throw data;
        }
    }

    umbrella.sendEvent = sendEvent;
 }
